import { Component, inject } from '@angular/core';
import { SurveyRenderControllerStore } from '../../render-store/render.store';

@Component({
  selector: 'lib-survey-error-occured',
  imports: [],
  templateUrl: './survey-error-occured.html',
  styleUrl: './survey-error-occured.css',
})
export class SurveyErrorOccured {
  surveyRenderStore = inject(SurveyRenderControllerStore);
}
